import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="linkbuilder-complex">
                <div className="linkbuilder-complex__wrapper">
                    <div className="linkbuilder-complex__info">
                        <CommonTitle>
                            Для кого <br />
                            наш сервис?
                        </CommonTitle>
                        <CommonUsualText></CommonUsualText>
                    </div>
                    <div className="linkbuilder-complex__list">
                        <div className="common__small-text">
                            Бизнес, который хочет выйти на&nbsp;мировой рынок, сталкивается
                            с&nbsp;проблемой ссылочного порога. В&nbsp;самых конкурентных
                            и&nbsp;привлекательных нишах, где, как правило, у&nbsp;всех игроков
                            хороший ассортимент, удобный и&nbsp;быстрый интерфейс, основным фактором
                            для выхода в&nbsp;ТОП поисковика становятся ссылки. И&nbsp;потому многие
                            проекты не&nbsp;имеют шансов выйти в&nbsp;ТОП естественной выдачи без
                            работы с&nbsp;линкбилдингом. В&nbsp;зависимости от&nbsp;сферы бизнеса,
                            необходимое количество внешних ссылок может быть от&nbsp;нескольких
                            десятков до&nbsp;сотен тысяч.
                        </div>
                        <div className="common__small-text">
                            Сейчас закупка внешних ссылок происходит вручную: владельцы бизнеса
                            оставляют запрос на&nbsp;биржах фрилансеров-линкбилдеров, которые
                            запрашивают стоимость на&nbsp;размещение гиперссылок у&nbsp;владельцев
                            подходящих площадок и&nbsp;выставляют счет. Координация работы
                            линкбилдеров требует очень много времени и&nbsp;зачастую ведется
                            с&nbsp;ограниченным количеством одних и&nbsp;тех&nbsp;же доноров.{' '}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
